import Vue from 'vue'
import axios from './vue-axios/axios'

export function hubListFromEntity(entity_id) {
  var params = { entity_id: entity_id }
  return Vue.axios.get('/v1/users/hubs', { params: params })
}

export function createHub(hub_params) {
  return Vue.axios.post('/v1/hubs', { name: hub_params.name, entity_id: hub_params.entity_id })
}

export function updateHub(hub_params) {
  return Vue.axios.put('/v1/hubs/' + hub_params.id, { name: hub_params.name,
                                                   id: hub_params.id,
                                                   services_ids: hub_params.services.map(service => service.id)})
}

export function deleteHub(hub_id) {
  return Vue.axios.delete('/v1/hubs/' + hub_id)
}

export function availableServicesForHub(hub_id) {
  return Vue.axios.get('/v1/hubs/' + hub_id + '/available_services')
}



// WEBPACK FOOTER //
// ./src/backend/hubs.js